import React, { createContext, useContext } from 'react';

// Shape carried by UserContext. Pulls the parent user profile + the
// subscription-action + the auth bootstrap callbacks out of the
// App.js prop chain. Downstream pages (ParentPage, LoginPage,
// ChildSignupPage, ChildAgeCheckPage, etc.) consume from here so
// the route tree stops threading them as props.
const UserContext = createContext({
  userProfile: null,
  setUserProfile: () => {},
  subscriptionAction: { action: 'none' },
  setSubscriptionAction: () => {},
  fetchUser: async () => {},
  logout: () => {},
  isUserLoading: true,
  isUS: null,
});

export function UserProvider({ value, children }) {
  return (
    <UserContext.Provider value={value}>{children}</UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
